import { render, staticRenderFns } from "./ListFactureClientsVal.vue?vue&type=template&id=2c129c50&scoped=true&"
import script from "./ListFactureClientsVal.vue?vue&type=script&lang=js&"
export * from "./ListFactureClientsVal.vue?vue&type=script&lang=js&"
import style0 from "./ListFactureClientsVal.vue?vue&type=style&index=0&id=2c129c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c129c50",
  null
  
)

export default component.exports